"use strict";

var React = require('react');
/**
 * Creates a mixin to use with react components that can manage getting localized text easily.
 * @param {LocalizationManager} localizationManager Pass in the LocalizationManager instance you want to use
 */
module.exports = function (localizationManager) {

    /**
     * Pulls localized text by key using props.lang and props.cntry to pull from the right data source
     * @param key
     */
    this.getLocalizedText = function (key, replacements) {
        //todo: what if lang or cntry is not in props? what do?
        var text = localizationManager.get(key, this.props.lang, this.props.cntry);
        if (replacements) {
            for (var prop in replacements) {
                var rep = "\\$\\{" + prop + "\\}";
                var reg = new RegExp(rep, "g");
                text = text.replace(reg, replacements[prop]);
            }
        }
        return text;
    };
};

module.exports.functionVersion = function (localizationManager) {
    return function (key, replacements, lang, cntry) {
        //todo: what if lang or cntry is not in props? what do?
        var text = localizationManager.get(key, lang, cntry);
        if (replacements) {
            for (var prop in replacements) {
                var rep = "\\$\\{" + prop + "\\}";
                var reg = new RegExp(rep, "g");
                text = text.replace(reg, replacements[prop]);
            }
        }
        return text;
    };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/localization/LocalizationMixin.js
// module id = 270
// module chunks = 0